// removed by extract-text-webpack-plugin
module.exports = {"InfoCampaign":"_1Lir8UG4iDEyOyDrONCTKn","headerBar":"_2kxsyx-e-92Jsc0y5QSChA","header":"_3N5HKLMXYVe3ZZO-wKfda2","subHeader":"_3nj4xuYJH7-G84uX4w8QEZ","animationInit":"_1PjAb-CX8va0j9oROJuEvM","animationInit2":"_1KV7f_mNimICEppJKlo3Eu","manchet":"_1arseBRA_U_CYg3ShmrLA4","dataTable":"_31FOtUAtXsuoLEChgQMj49","backgroundImage":"_1JG_cszlhgI5ZMMWEAwbak","content":"kqkrps06LYneJjfGyyZ6u","category":"_3_6WiZ1EhlTc1wZbsFM-Os"};


//////////////////
// WEBPACK FOOTER
// ./src/components/InfoCampaign/InfoCampaign.css
// module id = 492
// module chunks = 8